function objectEncodeAndDecodeOptions(defaultValue) {
    const encode_and_decode = {
        encode: (value) => JSON.stringify(value),
        decode: (value) => {
            if (value === null)
                return null;
            try {
                return JSON.parse(value);
            }
            catch {
                return null;
            }
        },
        defaultValue,
    };
    function curry_equality(equality_fn) {
        return { ...encode_and_decode, equalityFn: equality_fn };
    }
    return Object.assign(curry_equality, encode_and_decode);
}
function arrayEncodeAndDecodeOptions(defaultValue) {
    const encode_and_decode = {
        encode: (value) => JSON.stringify(value),
        decode: (value) => {
            if (value === null)
                return null;
            try {
                return JSON.parse(value);
            }
            catch {
                return null;
            }
        },
        defaultValue,
    };
    function curry_equality(equality_fn) {
        return { ...encode_and_decode, equalityFn: equality_fn };
    }
    return Object.assign(curry_equality, encode_and_decode);
}
export { objectEncodeAndDecodeOptions, arrayEncodeAndDecodeOptions };
